<template>
  <button
    tabindex="0"
    class="iconWrapper"
    @mouseover="isHovered = true"
    @mouseleave="isHovered = false"
    @click="$emit('click')"
  >
    <img :src="iconSrc" />
    <div class="tooltip">
      {{ tooltip }}
    </div>
  </button>
</template>

<script>
export default {
  name: "IconButton",
  props: {
    tooltip: {
      type: String,
      required: true,
    },
    iconSrc: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isHovered: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.iconWrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #0b9096;
  transition: color 0.3s;
  background: transparent;
  padding: 0;
  border: none;
  & img {
    color: #0b9096;
  }
  &:focus-visible {
    outline: 1px solid #000000;
    outline-offset: 2px;
    border-radius: 2px;
  }
  &:hover {
    color: #0b7a7e;
    cursor: pointer;
  }
}

.tooltip {
  position: absolute;
  top: 20px;
  left: auto;
  right: 0px;
  transform: translateX(0);
  background-color: #fff;
  border: 1px solid #8691a4;
  border-radius: 6px;

  padding: 4px 8px;

  font-size: 14px;
  color: #263141;
  line-height: 20px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;

  .iconWrapper:hover & {
    opacity: 1;
    pointer-events: auto;
  }
}
</style>
